import { BaseRepository } from './BaseRepository';
import Post, { IPost } from '../models/Post';
import handleResponseError from './utils/handleResponseError';

export default class PostRepository extends BaseRepository<Post> {
  static findAll({
    featured = false
  }: {
    featured?: boolean;
  } = {}): Promise<Post[]> {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };

    return fetch(
      `${this.apiUrl}/post${featured ? '?featured=1' : ''}`,
      requestOptions
    )
      .then(this.handleResponse)
      .then(({ data }) => {
        return data.map((item: IPost) => Post.createFromEntity(item));
      });
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        if (response.status === 401) {
        }

        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);
        return Promise.reject(error);
      }

      return res;
    });
  }
}
